export default "__VITE_ASSET__018f4fdf__"